module.exports = __webpack_public_path__ + "img/oasis-2.f53d2642.png";